// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2FaQg","textContent":"style_textContent__3N_XW","normalCase":"style_normalCase__252w3"};